<template>
  <app-modal v-model="isDialogOpened"
             size="xs"
             :ok-text="$t('common.confirm')"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>{{ $t('project.signing-checklist.add.step2.SigningChecklistAddStep2DeleteStepWarningDialog.title') }}</template>

    <template #body>
      <p>{{ $t("project.signing-checklist.add.step2.SigningChecklistAddStep2DeleteStepWarningDialog.warning") }}</p>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { dialogMixin } from '@/mixins/dialogMixin'

export default defineComponent({
  name: 'SigningChecklistAddStep2DeleteStepWarningDialog',
  mixins: [dialogMixin],
  emits: ['confirm'],
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
})
</script>
